// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3Ispf","actions":"GroupTable_actions__jMv-u","deleteModalFooter":"GroupTable_deleteModalFooter__2btd7"};